import axios, { AxiosInstance } from 'axios';
import { convertSnakeToCamel } from '@/utils';

const baseDomain = import.meta.env.VITE_TBS_PUBLIC_SERVER_DOMAIN;
const baseURL = `${baseDomain}/information`;

export const tbsJsonAxiosPublicServerClientController = new AbortController();
const signal = tbsJsonAxiosPublicServerClientController.signal;

/**
 * TBS公開サーバー 接続用 Axios インスタンス
 */
const repository: AxiosInstance = axios.create({ baseURL, signal });

const __DEBUG__ = import.meta.env.MODE !== 'prod';

repository.interceptors.response.use(
  (response) => {
    if (__DEBUG__) {
      console.debug(
        `[${response.config.method?.toUpperCase()}] ${response.config.url} => ${response.status}`,
        convertSnakeToCamel(response.data)
      );
    }

    if (response.data) {
      convertSnakeToCamel(response.data);
    }

    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default repository;
